export default __webpack_public_path__ + "static/SFMono-MediumItalic-44eb696cddc47f6012d679e1017d1945.woff";